module.exports = __webpack_public_path__ + "static/img/Marriot.e921f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Marriot.jpg
// module id = FIG7
// module chunks = 0